<script lang="ts" setup>
import { support } from '@config/support'

import TextQuaternary from '@UI/Typography/TextQuaternary.vue'
import FooterCopyright from '@Molecules/Footer/FooterCopyright.vue'

defineOptions({
  name: 'FooterMenu',
})

</script>

<template>
  <nav class="footer-menu">
    <FooterCopyright class="mobile" />
    <TextQuaternary
      class="footer-menu__item"
    >
      {{ support.email }}
    </TextQuaternary>
    <TextQuaternary
      v-once
      class="footer-menu__item"
    >
      Address Las Vegas, USA
    </TextQuaternary>
  </nav>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Footer/FooterMenu.scss" />
